document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.carousel').forEach(function (carousel) {
        const cards = carousel.querySelectorAll('.image-list-text');
        if (cards.length === 0) return;

        let maxHeight = 0;

        cards.forEach(function (card) {
            // reset any previously-set height so we measure natural height
            card.style.minHeight = '';
            const h = card.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });

        // 87 is the height of the icon and the title
        cards.forEach(function (card) {
            card.style.height = maxHeight + 87 + 'px';
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const isTouch = window.matchMedia('(hover: none)').matches;

    document.querySelectorAll('.hover-gif').forEach(function (img) {
        const staticSrc = img.src;
        const gifSrc = img.dataset.gif;
        if (!gifSrc) return;

        const pipsContainer = (img.closest('a') ?? img).parentElement.querySelector('.gif-pips');
        const pips = pipsContainer ? pipsContainer.querySelectorAll('.gif-pip') : [];

        if (isTouch) {
            // touch: auto-play the gif, hide pips (handled by CSS)
            img.src = gifSrc;
            return;
        }

        let pipTimer;
        let currentPip = 0;

        function setActivePip(index) {
            pips.forEach((pip, i) => pip.classList.toggle('active', i === index));
        }

        img.addEventListener('mouseenter', function () {
            img.src = gifSrc;
            currentPip = 0;
            setActivePip(0);
            if (pips.length > 0) {
                pipTimer = setInterval(function () {
                    currentPip = (currentPip + 1) % pips.length;
                    setActivePip(currentPip);
                }, 1500);
            }
        });

        img.addEventListener('mouseleave', function () {
            img.src = staticSrc;
            clearInterval(pipTimer);
            currentPip = 0;
            setActivePip(0);
        });
    });
});